<template>
  <footer>
    <div class="content flex-between-center">
      <div class="left flex-start-start">
        <div class="left-box"></div>
        <img
          class="logo"
          src="../../../assets/images/logo-text.png"
          alt="logo"
        />
        <span class="span-1"> 加入创作者生态</span>
        <span class="span-2">
          若您想在NVWA平台铸造发行数字藏品或建立任何形式合作，<br />请联系我们：service@nvwanft.cc
        </span>
        <span class="span-3" @click="$router.push('/report')" > <span class="jubao"></span> 我要举报</span>
      </div>
      <div class="right flex-start-start">
        <div class="right-box"></div>
        <!-- <div class="item flex-start-start link-left">
          <span  @click="routeLink('/index')">NVWA首页</span>
        </div>
        <div class="item flex-start-start link-left">
          <span  @click="routeLink('/news')">NVWA新闻</span>
        </div>
        <div class="item flex-start-start link-left">
          <span  @click="routeLink('/market')">NVWA市场</span>
          <div class="item-item item-item-market flex-start-start">
            <span @click="routeLink('market')">所有藏品</span>
            <span v-for="(v,k) in categoryListData" :key="k" @click="routeLink('/market', { categoryName: v.categoryName })">{{v.categoryName}}</span>
          </div>

        </div> -->
        <div class="item flex-start-start link-right">
          <!-- <span  @click="routeLink('/contact')">社区</span>
          <div class="item-item flex-start-start">
            <span @click="routeLink('/help')">帮助中心</span>
            <span @click="routeLink('/about')">关于我们</span>
          </div> -->

          <img
            class="code"
            src="../../../assets/images/weixin.jpg"
            alt="微信"
          />
        </div>
        <div class="item flex-start-start code">
          <div class="img-box flex-start-start">
            <div class="logo wechat">
              <img src="../../../assets/images/weixin.jpg" alt="微信" />
            </div>
            <!-- <div class="logo weibo"></div> -->
          </div>
        </div>
      </div>
      <div class="right-phone flex-start-start">
        <div class="right-box"></div>
        <!-- <div class="item flex-start-start link-left link-50">
          <span  @click="routeLink('/index')">NVWA首页</span>
        </div>
        <div class="item flex-start-start link-left link-50">
          <span  @click="routeLink('/news')">NVWA新闻</span>
        </div>
        <div class="item link-left link-100">
          <span  @click="routeLink('/market')">NVWA市场</span>
          <div class="item-item flex-start-start">
            <span @click="routeLink('market')">所有藏品</span>
            <span v-for="(v,k) in categoryListData" :key="k" @click="routeLink('/market', { categoryName: v.categoryName })">{{v.categoryName}}</span>
          </div>

        </div>
        <div class="item  link-right link-50">
          <span  @click="routeLink('/contact')">社区</span>
          <div class="item-item flex-start-start">
            <span class="link-50-50" @click="routeLink('/help')">帮助中心</span>
            <span class="link-50-50" @click="routeLink('/about')">关于我们</span>
          </div>

        </div> -->
        <div class="item flex-start-start link-50">
          <span @click="routeLink('/contact')">联系我们</span>
          <div class="img-box flex-start-start">
            <img src="../../../assets/images/weixin.jpg" alt="微信" />
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div style="width:100%;margin:0 auto; padding:20px 0;">
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="display:inline-block;text-decoration:none;"
        >
          <p style="float:left;margin: 0px 0px 0px 5px; color:#939393;">
            Copyright ©2021 女娲NVWA 湘ICP备2021015976号-1
          </p>
        </a>
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43310102000313"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        >
          <img
            src="../../../assets/images/icon/supervision_pic.png"
            style="float:left;width:20px"
          />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            湘公网安备 43310102000313号
          </p>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { categoryList } from '../../../request/api.js'
export default {
  components: {},
  data() {
    return {
      categoryListData: []
    }
  },
  created() {
    // this.getCategoryList()
  },
  methods: {
    getCategoryList() {
      categoryList().then(res => {
        this.categoryListData = res.data
      })
    },
    routeLink(path, query) {
      const newLink = this.$router.resolve({ path: path, query: query })
      window.open(newLink.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  background-color: white;
  @media screen and(max-width:768px) {
    height: 421px;
  }
}
.content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  height: 430px;
  align-items: end;
  @media screen and(max-width:768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 421px;
  }
  .left {
    position: relative;
    .left-box {
      position: absolute;
      z-index: -1;
      width: 617px;
      height: 450px;
      border-radius: 50%;
      background: linear-gradient(
        306deg,
        rgba(255, 255, 255, 0.19) 0%,
        rgba(232, 114, 29, 0.19) 100%
      );
      filter: blur(35px);
      @media screen and(max-width:768px) {
        width: 100%;
        height: 200px;
      }
    }

    width: 617px;
    height: 400px;
    @media screen and(max-width:768px) {
      width: calc(100% - 40px);
      height: 200px;
      margin-top: 40px;
      // padding: 0 20px;
    }
    flex-direction: column;
    // filter: blur(35px);
    img {
      width: 130px;
      margin: 150px 0 20px 0;
      @media screen and(max-width:768px) {
        margin: 10px 0 10px 0;
        width: 140px;
      }
    }
    .span-1 {
      font-size: 28px;
      color: #444444;
      font-weight: 600;
      margin: 30px 0 30px 0;
      @media screen and(max-width:768px) {
        margin: 10px 0 10px 7px;
        font-size: 18px;
        font-weight: 600;
        color: #444444;
        line-height: 25px;
      }
    }
    .span-2 {
      font-size: 14px;
      color: #444444;
      font-weight: 400;
      margin-left: 0;
      @media screen and(max-width:768px) {
        margin-left: 7px;
        font-size: 11px;
        font-weight: 400;
        color: #444444;
        line-height: 18px;
      }
    }
    .span-3 {
      font-size: 14px;
      color: #444444;
      font-weight: 400;
      margin-top: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 20px;
      .jubao {
        width: 17px;
        height: 20px;
        background-image: url('../../../assets/images/jubao.png');
        background-size: 100%;
        background-repeat: no-repeat;
      }
      @media screen and(max-width:768px) {
        margin-left: 7px;
        font-size: 11px;
        font-weight: 400;
        color: #444444;
        line-height: 18px;
      }
      &:hover {
        color: #E8721D;
      }
    }
  }
  .right {
    position: relative;
    display: flex;
    @media screen and(max-width:768px) {
      display: none;
    }
    .right-box {
      position: absolute;
      right: 50px;
      top: -130px;
      z-index: -1;
      width: 200px;
      height: 200px;
      border-radius: 50%;
      background: linear-gradient(
        306deg,
        rgba(255, 255, 255, 0.19) 0%,
        rgba(232, 114, 29, 0.19) 100%
      );
      filter: blur(35px);
      @media screen and(max-width:768px) {
        width: 100%;
      }
    }
    .code {
      @media screen and(max-width:768px) {
        display: none;
      }
    }
    .item {
      flex-direction: column;
      margin-right: 50px;
      @media screen and(max-width:768px) {
        margin-right: 0;
      }
      > span {
        font-size: 14px;
        font-weight: 500;
        color: #444444;
        line-height: 20px;
      }
      span {
        cursor: pointer;
        margin-bottom: 25px;
        font-size: 14px;
        color: #444444;
        &:hover {
          text-decoration: underline;
        }
        @media screen and(max-width:768px) {
          font-size: 12px;
          font-weight: 400;
          color: #7d7d7d;
          line-height: 19px;

          margin-bottom: 20px;
        }
      }
      .item-item {
        flex-wrap: wrap;
        span {
          display: inline-block;
          width: 100%;
          font-size: 13px;
          font-weight: 400;
          color: #757575;
          line-height: 18px;
          flex-shrink: 0;
        }
      }
      .item-item-market {
        width: 200px;
        span {
          display: inline-block;
          width: 50%;
        }
      }
      .code {
        width: 120px;
        position: relative;
        left: -40px;
        display: none;
        @media screen and(max-width:768px) {
          left: 0;
          top: -10px;
          width: 59px;
          display: block;
        }
      }
      .img-box {
        .logo {
          // width: 40px;
          // height: 40px;
          border-radius: 50%;
          margin-right: 37px;
          cursor: pointer;
          &:hover {
            img {
              display: block;
            }
          }
          img {
            width: 120px;
            position: relative;
            left: -40px;
            @media screen and(max-width:768px) {
              left: 0;
              top: -10px;
              width: 90px;
            }
          }
        }
        .wechat {
          // background: url('../../../assets/images/icon/wechat-grey-icon.png');
          // background-size: cover;
          // &:hover {
          //   background: url('../../../assets/images/icon/wechat-icon.png');
          //   background-size: cover;
          // }
        }
        .weibo {
          background: url('../../../assets/images/icon/weibo-grey-icon.png');
          background-size: cover;
          &:hover {
            background: url('../../../assets/images/icon/weibo-icon.png');
            background-size: cover;
          }
        }
      }
    }
    .link-left {
      @media screen and(max-width:768px) {
        margin-left: 3px;
      }
    }
    .link-right {
      @media screen and(max-width:768px) {
        margin-right: 32px;
      }
    }
    @media screen and(max-width:768px) {
      width: calc(100% - 40px);
      padding: 0 20px;
      justify-content: space-between;
    }
  }
  @media screen and(max-width:768px) {
    width: 100%;
    min-width: 100%;
  }
  .right-phone {
    display: none;
    @media screen and(max-width:768px) {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      width: 100%;
      padding: 0 20px;
      .link-50 {
        width: 50%;
      }
      .link-100 {
        width: 100%;
      }
      .item {
        margin-top: 27px;
        flex-direction: column;
        > span {
          font-size: 11px;
          font-weight: 400;
          color: #484848;
          line-height: 19px;
          margin-left: 7px;
        }
        img {
          width: 90px;
          // height: 58px;
          // margin-left: 20px;
        }
        flex-shrink: 0;
        .item-item {
          flex-wrap: wrap;

          span {
            flex-shrink: 0;
            display: inline-block;
            width: 20%;
            font-size: 9px;
            font-weight: 400;
            color: #8f8f8f;
            line-height: 13px;
            margin-top: 9px;
          }
          .link-50-50 {
            width: 50%;
          }
        }
      }
    }
  }
}
.copyright {
  background: white;
  width: 100%;
  // padding: 0 0 24px 0;
  text-align: center;
  font-size: 14px;
  color: #444444;
  @media screen and(max-width:768px) {
    margin: 0 auto;
    width: 100%;
    font-size: 10px;
    color: #7e7e7e;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/cun-footer.vue